import { Location } from 'history';
import { useRef } from 'react';
import { useAliveController } from 'react-activation';
import { useDispatch } from 'react-redux';
import { APP_URL } from 'shared/constants/common';
import { createLogger } from 'shared/logger';
import { fetchPopularCategories } from '../../../store/categories';
import { CacheComponentKeys } from '../CacheView.types';

const cacheViewResetList: Record<string, CacheComponentKeys[]> = {
	[APP_URL.sport]: ['sport', 'popular-sport'],
	[APP_URL.eSport]: ['esport'],
	[APP_URL.live]: ['live'],
	[APP_URL.promotion]: ['promotion'],
	[APP_URL.home]: ['home'],
};
export const useCacheView = () => {
	const logger = createLogger('useCacheView');
	const { refreshScope } = useAliveController();
	const isRefreshing = useRef(false);
	const dispatch = useDispatch();

	const resetCacheViewByUrl = (newLocation: Location, oldLocation: Location) => {
		if (isRefreshing.current) return;
		const keys = cacheViewResetList[newLocation.pathname];
		if (keys) {
			isRefreshing.current = true;
			keys.forEach((key) => {
				logger.log('Refresh:', key);
				if (key === 'live' && newLocation.hash) {
					return;
				}
				if (key === 'sport') {
					if (newLocation.pathname === oldLocation.pathname) {
						return;
					}

					dispatch(fetchPopularCategories(undefined));
				}
				if (key === 'esport' && newLocation.pathname === oldLocation.pathname) {
					return;
				}
				refreshScope(key);
			});
			setTimeout(() => {
				isRefreshing.current = false;
			}, 1000);
		}
	};

	return {
		resetCacheViewByUrl,
	};
};
